import { useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqItems = [
  { q: "faq1Q", a: "faq1A" },
  { q: "faq2Q", a: "faq2A" },
  { q: "faq3Q", a: "faq3A" },
  { q: "faq4Q", a: "faq4A" },
  { q: "faq5Q", a: "faq5A" },
];

export default function FaqPage() {
  const { t } = useTranslation();
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("sectionFaq")}
              </h1>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                Find answers to common questions about the AllChinaBuy spreadsheet, shopping process, shipping, safety, and more.
              </p>
            </div>

            <div className="space-y-3">
              {faqItems.map((faq, index) => (
                <div
                  key={index}
                  className="rounded-xl border border-background-200/70 bg-background-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left"
                  >
                    <span className="font-semibold text-sm md:text-base text-foreground-900 pr-4">
                      {t(faq.q)}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line text-foreground-400 transition-transform shrink-0 ${
                        openFaq === index ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {openFaq === index && (
                    <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-200/70 pt-4">
                      {t(faq.a)}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-10 p-6 md:p-8 rounded-2xl bg-primary-500/10 border border-primary-200/50 text-center">
              <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">Still have questions?</h3>
              <p className="text-foreground-600 mb-6 text-sm">Explore the AllChinaBuy spreadsheet or check our guides for more information.</p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-block px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors"
              >
                {t("heroCtaPrimary")}
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}